export const TID = {
  // Login
  loginBox: "login-box",
  loginGoogleBtn: "login-google-btn",
  loginMockBtn: "login-mock-btn",
  loginError: "login-error",
  loginReadBadge: "login-read-badge",

  // App shell
  appShell: "app-shell",
  sidebar: "app-sidebar",
  sidebarLogout: "sidebar-logout",
  topbar: "app-topbar",
  topbarUser: "topbar-user-email",
  navDashboard: "nav-dashboard",
  navLeads: "nav-leads",
  navClients: "nav-clients",
  navAgents: "nav-agents",
  navMemograph: "nav-memograph",
  navGovernance: "nav-governance",
  navQuotes: "nav-quotes",
  navPrds: "nav-prds",
  navIntegrations: "nav-integrations",
  navSettings: "nav-settings",

  // Dashboard
  dashboard: "dashboard-page",
  kpiClients: "kpi-clients-active",
  kpiQuotes: "kpi-quotes-open",
  kpiProjects: "kpi-projects-active",
  kpiAgents: "kpi-agents-up",
  feedPanel: "feed-panel",
  feedItem: "feed-item",

  // Leads
  leadsPage: "leads-page",
  leadsTable: "leads-table",
  leadRow: "lead-row",
  leadNewBtn: "lead-new-btn",
  leadForm: "lead-form",
  leadFormCompany: "lead-form-company",
  leadFormSector: "lead-form-sector",
  leadFormNeed: "lead-form-need",
  leadFormBudget: "lead-form-budget",
  leadFormEmail: "lead-form-email",
  leadFormSubmit: "lead-form-submit",
  leadDetail: "lead-detail-page",
  leadGenQuoteBtn: "lead-generate-quote-btn",
  leadGenPrdBtn: "lead-generate-prd-btn",

  // Quotes
  quotesPage: "quotes-page",
  quotesTable: "quotes-table",
  quoteRow: "quote-row",
  quoteDetail: "quote-detail-page",
  quoteItemsTable: "quote-items-table",
  quoteTotalRow: "quote-total-row",

  // PRDs
  prdsPage: "prds-page",
  prdsTable: "prds-table",
  prdRow: "prd-row",
  prdDetail: "prd-detail-page",

  // Clients
  clientsPage: "clients-page",
  clientCard: "client-card",
  clientDetail: "client-detail-page",
  projectItem: "project-item",

  // Agents
  agentsPage: "agents-page",
  agentCard: "agent-card",

  // Memograph
  memographPage: "memograph-page",
  memographInput: "memograph-search-input",
  memographSubmit: "memograph-search-submit",
  memographTabSemantic: "memograph-tab-semantic",
  memographTabGraph: "memograph-tab-graph",
  memographTabFile: "memograph-tab-file",
  memographResult: "memograph-result",

  // Governance
  governancePage: "governance-page",
  loopItem: "loop-item",
  decisionItem: "decision-item",

  // 2FA modal (write actions)
  twoFaModal: "two-factor-modal",
  twoFaInput: "two-factor-input",
  twoFaConfirm: "two-factor-confirm",
  twoFaCancel: "two-factor-cancel",
  twoFaError: "two-factor-error",

  // Theme toggle
  themeToggle: "theme-toggle",
  themeToggleLight: "theme-toggle-light",
  themeToggleDark: "theme-toggle-dark",

  // Integrations
  integrationsPage: "integrations-page",
  integrationsFilter: "integrations-filter",
  integrationCard: "integration-card",
  integrationConnectBtn: "integration-connect-btn",
  integrationDisconnectBtn: "integration-disconnect-btn",
  integrationDialog: "integration-dialog",
  integrationDialogKey: "integration-dialog-key",
  integrationDialogScope: "integration-dialog-scope",
  integrationDialogSave: "integration-dialog-save",

  // Settings
  settingsPage: "settings-page",
  settingsProfile: "settings-profile",
  settingsUi: "settings-ui",
  settingsNotifications: "settings-notifications",
  settingsGovernance: "settings-governance",
  settingsSecurity: "settings-security",
  settingsSaveBtn: "settings-save-btn",

  // Dashboard v2 widgets
  focusPanel: "focus-panel",
  agentHealthPanel: "agent-health-panel",
  milestonesPanel: "milestones-panel",
  eventsPanel: "events-panel",
  decisionsPanel: "decisions-panel",
};
